import React from "react";
import Helmet from "../components/Helmet/Helmet";

const Privacy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Roha Jewellery | Ethiopian Gemstone Jewelry Store</title>
      <meta name="description" content="🌟 Read Roha Jewellery's privacy policy. Learn how we protect your personal information when shopping for Ethiopian gemstone jewelry. Secure, transparent data practices." />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://rohajewellery.com/privacy" />
    </Helmet>
    <div className="container py-5" style={{ color: '#222' }}>
    <h1 className="gold-gradient mb-4">Roha Jewellery – Privacy Policy</h1>
    <p>Last Updated: June 2024</p>
    <h2>1. Introduction</h2>
    <p>Roha Jewellery is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website.</p>
    <h2>2. Information We Collect</h2>
    <ul>
      <li><b>Personal Information:</b> Name, email, phone, address, password (hashed), avatar, and role.</li>
      <li><b>Order & Transaction Data:</b> Purchase history, order status, delivery details, payment method (processed via third-party gateways).</li>
      <li><b>Custom Design Requests:</b> Name, email, phone, design images, and notes.</li>
      <li><b>Device & Usage Data:</b> IP address, browser type, device info, cookies, and analytics.</li>
      <li><b>Communications:</b> Messages sent via contact forms, blog comments, and newsletter subscriptions.</li>
    </ul>
    <h2>3. How We Use Your Information</h2>
    <ul>
      <li>To process orders, payments, and deliver products.</li>
      <li>To manage your account, roles, and provide customer support.</li>
      <li>To review and fulfill custom design requests.</li>
      <li>To improve our website, personalize your experience, and analyze usage.</li>
      <li>To send updates, offers, and marketing (opt-out available).</li>
      <li>To comply with legal obligations and prevent fraud.</li>
    </ul>
    <h2>4. Sharing & Disclosure</h2>
    <ul>
      <li>We do not sell or rent your personal data.</li>
      <li>We may share information with service providers (e.g., payment processors, delivery partners) as needed to fulfill your orders.</li>
      <li>We may disclose information if required by law or to protect our rights.</li>
    </ul>
    <h2>5. Data Security</h2>
    <ul>
      <li>We use secure servers, encryption, and password hashing to protect your data.</li>
      <li>No method of transmission is 100% secure; please safeguard your credentials.</li>
    </ul>
    <h2>6. Cookies & Analytics</h2>
    <ul>
      <li>We use cookies and analytics tools to improve website performance and user experience.</li>
      <li>You may manage cookie preferences in your browser settings.</li>
    </ul>
    <h2>7. Your Rights</h2>
    <ul>
      <li>You may request access to or correction of your personal data.</li>
      <li>You may request deletion of your account and data.</li>
      <li>You may opt out of marketing communications at any time.</li>
    </ul>
    <h2>8. Data Retention</h2>
    <p>We retain your data as long as necessary to provide our services and comply with legal obligations. You may request deletion at any time.</p>
    <h2>9. Third-Party Links</h2>
    <p>Our website may contain links to third-party sites. We are not responsible for their privacy practices.</p>
    <h2>10. Changes to This Policy</h2>
    <p>We may update this Privacy Policy periodically. Continued use of our website after updates signifies your acceptance of the changes.</p>
    <h2>11. Contact Us</h2>
    <p>For questions or concerns, contact us at <a href="mailto:info@rohajewellery.com">info@rohajewellery.com</a>.</p>
    </div>
  </>
);

export default Privacy;
